<div class="flex items-center gap-8">
  @if (userInfo) {
  <div class="prime-menu-container">
    <button #menuButton class="menu-button" (click)="toggleMenu($event)">
      <div class="avatar-container">
        <img [src]="userInfo.avatar_url" alt="Profile" class="avatar-image" />
      </div>
      <div class="user-info">
        <span class="user-name">{{ userInfo.name }}</span>
      </div>
      <span class="pi pi-angle-down dropdown-icon"></span>
    </button>

    <p-menu
      #menu
      [model]="menuItems"
      [popup]="true"
      [appendTo]="'body'"
      styleClass="prime-custom-menu"
    >
      <ng-template pTemplate="item" let-item>
        <div [ngSwitch]="item.template">
          <!-- Regular Menu Item -->
          <div *ngSwitchCase="'regularItem'" class="regular-menu-item">
            <a
              (click)="item.command && item.command()"
              class="p-menuitem-link"
              [ngClass]="{ 'p-disabled': item.disabled }"
            >
              <span [class]="item.icon" *ngIf="item.icon" class="mr-2"> </span>
              <span class="p-menuitem-text">{{ item.label }}</span>
            </a>
          </div>

          <!-- Server URL Template
          <div *ngSwitchCase="'serverTemplate'" class="server-input-container">
            <div class="server-input-label">
              <i class="pi pi-server mr-2"></i>
              Server URL
            </div>
            <div class="server-input-wrapper">
              <input
                #serverInput
                pInputText
                class="server-input"
                placeholder="Server address"
                [value]="userSettings.serverUrl || ''"
                (click)="$event.stopPropagation()"
                (keyup.enter)="updateServerUrl(); $event.stopPropagation()"
              />
              <button
                pButton
                icon="pi pi-check"
                class="p-button-sm p-button-primary"
                (click)="updateServerUrl(); $event.stopPropagation()"
              >
                Submit
              </button>
            </div>
          </div> -->

          <!-- Provider Template -->
          <!-- @if(showProviders){
          <div *ngSwitchCase="'providerTemplate'" class="provider-section">
            <div class="provider-header">
              <i class="pi pi-cloud mr-2"></i>
              AI Provider
            </div>
            <div class="provider-options">
              <div
                *ngFor="let provider of providers"
                class="provider-option"
                (click)="changeProvider(provider); $event.stopPropagation()"
              >
                <p-radioButton
                  [value]="provider"
                  [ngModel]="selectedProvider"
                  (ngModelChange)="changeProvider($event)"
                  [inputId]="'provider_' + provider"
                >
                </p-radioButton>
                <label
                  [for]="'provider_' + provider"
                  class="provider-label"
                >
                  {{ provider | titlecase }}
                </label>
              </div>
            </div>
            <div class="debug-info">
              <i class="pi pi-info-circle mr-2"></i>
              Current provider: {{ selectedProvider }}
            </div>
          </div>
          } -->
        </div>
      </ng-template>
    </p-menu>
  </div>
  } @else {
    <div class="flex items-center gap-3 mr-3">
    @if(page != 'signup') {
    <a href="/signup">
      <button class="group flex items-center gap-2 px-5 py-2 rounded-full bg-gradient-to-br from-[#1594fd] via-[#06b6d4] to-[#0d7fe6] border border-transparent shadow-[0_4px_14px_rgba(21,148,253,0.3)] cursor-pointer transition-all duration-200 ease-out hover:-translate-y-px hover:shadow-[0_8px_24px_rgba(21,148,253,0.45)] active:translate-y-0 active:scale-[0.98]">
        <span class="text-sm font-bold tracking-wide text-white">Sign up</span>
        <span class="pi pi-user-plus text-xs text-white transition-transform duration-200 ease-out group-hover:scale-110"></span>
      </button>
    </a>
    }
    @if(page != 'login') {
    <a href="/login">
      <button class="group flex items-center gap-2 px-5 py-2 rounded-full bg-white/50 backdrop-blur-xl border border-white/40 shadow-[0_4px_14px_rgba(21,148,253,0.12),inset_0_1px_0_rgba(255,255,255,0.6)] cursor-pointer transition-all duration-200 ease-out hover:-translate-y-px hover:border-[#1594fd] hover:bg-white/60 hover:shadow-[0_8px_24px_rgba(21,148,253,0.22),inset_0_1px_0_rgba(255,255,255,0.7)] active:translate-y-0 active:scale-[0.98]">
        <span class="text-sm font-bold tracking-wide bg-gradient-to-br from-[#1594fd] via-[#06b6d4] to-[#0d7fe6] bg-clip-text text-transparent">login</span>
        <!-- <span class="pi pi-sign-in text-sm text-[#1594fd] transition-transform duration-200 ease-out group-hover:scale-110"></span> -->
        <span class="pi pi-arrow-right text-xs text-[#1594fd] transition-transform duration-200 ease-out group-hover:translate-x-1"></span>
      </button>
    </a>
    }
    </div>
  }
</div>
